__webpack_require__.p = "//static.m2.ru//search/4f07e5fe/";